import axios from "axios"

const fetchStripePublicKey = async () => {
  const resp = await axios.get("config.json")
  return resp.data.stripe_publishable_key
}

export default fetchStripePublicKey
